module.exports = {"id":"212947","name":"Jimmy Cabot","rating":"73","photo":"./data/images/photos/1/212947.png","club":{"name":"FC Lorient","logo":"./data/images/clubs/FCLorient.png"},"positions":["MD","MG","BU"],"photoFolderIndex":1}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/JimmyCabot0.json
// module id = 2020
// module chunks = 0